import { QUEST_STATUSES } from '@didaskill/domain/user-achievements/constants';
import { TILE_VARIANTS } from '@didaskill/ui/design-system';

export const QUEST_TILE_VARIANTS_MAP: Record<QUEST_STATUSES, TILE_VARIANTS> = {
  [QUEST_STATUSES.IN_PROGRESS]: TILE_VARIANTS.NEUTRAL,
  [QUEST_STATUSES.COMPLETED]: TILE_VARIANTS.SUCCESS,
  [QUEST_STATUSES.LOCKED]: TILE_VARIANTS.NEUTRAL,
};

export const HIDDEN_TITLE = '???';
